/* Coming Soon / Waitlist / Countdown / Early Access — Rage.byp
 * The theme never unlocks purchase here: the real unlock is setting custom.coming_soon = false.
 * Early access only sends a SHA-256 hash (never the password) to a cart attribute;
 * the comparison happens server-side in Liquid (snippets/cs-lock-state.liquid).
 */
(function () {
  if (window.__csInit) return;
  window.__csInit = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function store(kind) {
    try { var s = window[kind]; var k = '__cs_t'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; }
  }
  var ls = store('localStorage');
  var ss = store('sessionStorage');
  function get(s, k) { try { return s ? s.getItem(k) : null; } catch (e) { return null; } }
  function set(s, k, v) { try { if (s) s.setItem(k, v); } catch (e) {} }
  function del(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }

  function strings() {
    var el = document.querySelector('script[data-cs-strings]');
    if (!el) return {};
    try { return JSON.parse(el.textContent); } catch (e) { return {}; }
  }
  var S = strings();

  function showMsg(el, text, type) {
    if (!el) return;
    el.textContent = text;
    el.classList.remove('cs-msg--error', 'cs-msg--success');
    if (type) el.classList.add('cs-msg--' + type);
    el.hidden = !text;
  }
  function pad(n) { return n < 10 ? '0' + n : String(n); }

  /* ---------- Countdown ---------- */
  function initCountdown(el) {
    var drop = parseInt(el.getAttribute('data-drop-ts'), 10) * 1000;
    if (!drop) { el.hidden = true; return; }
    var d = el.querySelector('[data-cs-days]'), h = el.querySelector('[data-cs-hours]'),
        m = el.querySelector('[data-cs-minutes]'), s = el.querySelector('[data-cs-seconds]');
    var timer;
    var demo = el.hasAttribute('data-cs-demo');
    var wasRunning = false;
    function tick() {
      var diff = Math.floor((drop - Date.now()) / 1000);
      if (diff <= 0) {
        el.hidden = true;
        clearInterval(timer);
        // Drop reached while the page was open: reload once, the theme
        // then renders the product unlocked (drop date passed = normal product).
        if (wasRunning && !demo) setTimeout(function () { window.location.reload(); }, 1500);
        return;
      }
      wasRunning = true;
      d.textContent = pad(Math.floor(diff / 86400));
      h.textContent = pad(Math.floor((diff % 86400) / 3600));
      m.textContent = pad(Math.floor((diff % 3600) / 60));
      s.textContent = pad(diff % 60);
    }
    tick();
    timer = setInterval(tick, 1000);
  }

  /* ---------- Waitlist (native customer form) ---------- */
  function initWaitlist(wrap) {
    var pid = wrap.getAttribute('data-product-id');
    var form = wrap.querySelector('form');
    var done = wrap.querySelector('[data-cs-waitlist-done]');
    var msg = form ? form.querySelector('.cs-msg') : null;
    var email = form ? form.querySelector('input[type="email"]') : null;
    var consent = form ? form.querySelector('input[type="checkbox"]') : null;
    var key = 'cs_wl_' + pid;
    if (!form) return;

    function setDone(isDone) {
      form.hidden = isDone;
      done.hidden = !isDone;
    }

    // Result of a submission that just came back from /contact
    var params = new URLSearchParams(window.location.search);
    var pending = get(ss, 'cs_wl_pending');
    if (pending === pid) {
      del(ss, 'cs_wl_pending');
      var ok = form.querySelector('[data-cs-posted="success"]');
      var err = form.querySelector('[data-cs-posted="error"]');
      if (ok || (params.get('customer_posted') === 'true' && !err)) {
        set(ls, key, 'joined');
      } else if (err) {
        showMsg(msg, S.waitlistError || 'Error', 'error');
      }
    }

    if (get(ls, key) === 'joined') setDone(true);

    form.addEventListener('submit', function (e) {
      var value = (email.value || '').trim();
      email.value = value;
      if (!EMAIL_RE.test(value)) {
        e.preventDefault();
        email.setAttribute('aria-invalid', 'true');
        showMsg(msg, S.invalidEmail || 'Invalid email', 'error');
        email.focus();
        return;
      }
      email.removeAttribute('aria-invalid');
      if (!consent.checked) {
        e.preventDefault();
        showMsg(msg, S.consentRequired || 'Consent required', 'error');
        consent.focus();
        return;
      }
      showMsg(msg, '', null);
      set(ss, 'cs_wl_pending', pid);
    });

    var reset = wrap.querySelector('[data-cs-waitlist-reset]');
    if (reset) reset.addEventListener('click', function () {
      del(ls, key);
      form.reset();
      setDone(false);
      email.focus();
    });
  }

  /* ---------- Early access (cosmetic gate) ---------- */
  function sha256Hex(text) {
    var data = new TextEncoder().encode(text);
    return window.crypto.subtle.digest('SHA-256', data).then(function (buf) {
      return Array.prototype.map.call(new Uint8Array(buf), function (b) {
        return ('0' + b.toString(16)).slice(-2);
      }).join('');
    });
  }

  function initEarlyAccess(form, blockState) {
    var pid = form.getAttribute('data-product-id');
    var input = form.querySelector('input');
    var btn = form.querySelector('button[type="submit"]');
    var msg = form.querySelector('.cs-msg');
    var tryKey = 'cs_ea_try';

    if (get(ss, tryKey) === pid) {
      del(ss, tryKey);
      if (blockState === 'locked') showMsg(msg, S.eaWrong || 'Wrong password', 'error');
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var pw = (input.value || '').trim();
      if (!pw) { showMsg(msg, S.eaEmpty || 'Enter the password', 'error'); input.focus(); return; }
      if (!window.crypto || !window.crypto.subtle) { showMsg(msg, S.eaError || 'Error', 'error'); return; }
      btn.disabled = true;
      showMsg(msg, S.eaChecking || '…', null);
      sha256Hex(pid + ':' + pw).then(function (hash) {
        var attrs = {}; attrs['ea_' + pid] = hash;
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        return fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: attrs })
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        set(ss, tryKey, pid);
        input.value = '';
        window.location.reload();
      }).catch(function () {
        btn.disabled = false;
        showMsg(msg, S.eaError || 'Error', 'error');
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-cs-block]').forEach(function (block) {
      if (block.__csDone) return;
      block.__csDone = true;
      var state = block.getAttribute('data-cs-state');
      var cd = block.querySelector('[data-cs-countdown]');
      if (cd) initCountdown(cd);
      var wl = block.querySelector('[data-cs-waitlist]');
      if (wl) initWaitlist(wl);
      var ea = block.querySelector('[data-cs-ea-form]');
      if (ea) initEarlyAccess(ea, state);
      // If unlocked state was confirmed, clear any pending "try" flag
      if (state === 'unlocked') del(ss, 'cs_ea_try');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
